import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoginHeroComponent } from "./login-hero.component";

/**
 * Modulo condiviso che espone `LoginHeroComponent` — pannello destro con
 * onde brand-gradient animate + 4H bubbles fluttuanti. Riusato dal login
 * admin/cliente e dalle schermate di stato di /public/:slug, senza
 * duplicazione di markup/stili.
 */
@NgModule({
  declarations: [LoginHeroComponent],
  imports: [CommonModule],
  exports: [LoginHeroComponent],
})
export class LoginHeroModule {}
